import classNames from 'classnames';
import React, { useState } from 'react';
import { Container } from '../components/layout/ContainerFlex';
import { SKUData } from './sku-profiling';
import SKUAnalysisView from './SKUAnalysisView';
import { SKUProvider } from './SKUContext';
import SKUDataUploader from './SKUDataUploader';
import SKUGroupAnalysisView from './SKUGroupAnalysisView';

const SimulationForecastView: React.FC = () => {
  const [skuData, setSkuData] = useState<SKUData[]>([]);

  return (
    <Container
      col
      hasOverflowY
      componentName={`SimulationForecastView`}
      className={classNames(
        'flex-1',
        'border-app-panel-dark ltr:border-l rtl:border-r',
      )}
    >
      <Container col hasOverflowY className={classNames('relative !h-auto')}>
        <SKUProvider>
          <SKUDataUploader />
          <SKUGroupAnalysisView  />
          <SKUAnalysisView />
          {/* <SKUAnalysisView skuData={skuData} /> */}
        </SKUProvider>
      </Container>
    </Container>
  );
};

export default SimulationForecastView;
